module.exports = __webpack_public_path__ + "static/media/bg.b2b53a20.jpg";